module.exports = __webpack_public_path__ + "static/img/14001036.13fb4f43.png";